import React from 'react';
import { Link } from 'react-router-dom';

function CardItem({
    title,
    labels,
    img,
    path
}) {
    let label = labels[0];
    return (
        <>
            <li className='cards__item'>
                <Link className='cards__item__link' to={path}>
                    <figure className='cards__item__pic-wrap' data-category={label}>
                        <img className='cards__item__img' alt={title} src={img} />
                    </figure>
                    <div className='cards__item__info'>
                        <h5 className='cards__item__text'>{title}</h5>
                    </div>
                </Link>
            </li>
        </>
    );
}

export default CardItem;
